module.exports = __webpack_public_path__ + "static/media/tuer_btn_falsch.cea31e02.jpg";